import { query, where , orderBy } from "firebase/firestore";
import {
  couponsCollectionRef,
  cSuiteCollectionRef,
  contentsCollectionRef,
  lifestyleCollectionRef,
  announcementsRef,
  userCollectionRef,
  designationsCollectionRef,
  keysCollectionRef,
} from "./firestoreHelpers";

export const cSuiteCollectionQuery = (status, time) => {
  if (status === "Code Expired") {
    return query(
      cSuiteCollectionRef,
      where("status", "==", "Sent Email"),
      where("expiry_time", "<", time)
    );
  } else if (status === "Sent Email") {
    return query(
      cSuiteCollectionRef,
      where("status", "==", "Sent Email"),
      where("expiry_time", ">", time)
    );
  }
  return query(cSuiteCollectionRef, where("status", "==", status));
};

export const couponQuery = (status, time) => {
  if (status === "Expired") {
    return query(couponsCollectionRef, where("date", "<", time));
  }
  return query(couponsCollectionRef, where("date", ">", time));
};

export const contentQuery = ({ status, type, time }) => {
  if (status === "Expired") {
    return query(
      contentsCollectionRef,
      where("type", "==", type),
      where("date", "<", time)
    );
  }
  return query(
    contentsCollectionRef,
    where("type", "==", type),
    where("date", ">", time)
  );
};

export const announcementsQuery = ({ status }) => {
  if (status === "Expired") {
    // Show all expired announcements (even if deleted)
    return query(
      announcementsRef,
      where("expired", "==", true || "deleted", "==", false),
    );
  }

  // For "Active": only not expired and not deleted
  return query(
    announcementsRef,
    where("expired", "==", false),
    where("deleted", "==", false)
  );
};

export const lifestyleQuery = (status, time) => {
  if (status === "Expired") {
    return query(lifestyleCollectionRef, where("date_to", "<", time));
  }
  return query(lifestyleCollectionRef, where("date_to", ">", time));
};

export const usersQuery = () => {
  // return query(userCollectionRef, where("private_key", "!=", null));
  return query(
    userCollectionRef
    // where("deleted", "==", null)
    // where("deleted", "==", false),
  );
};

export const designationQuery = () => {
  return query(designationsCollectionRef);
};

export const adminAuthQuery = () => {
  return query(keysCollectionRef, orderBy("date", "desc"));
};
